// Only transport/gateway failures can fall back to messages already received
// for this login. A permission denial or missing conversation stays explicit.
export function isTransientConversationLoadError(error) {
  return [0, 502, 503, 504].includes(error?.status);
}
